import { Button } from '../../../atoms/Button';
import { useState } from 'react';
import { ContentReportModal } from '../ContentReportModal';

interface IContentReportProps {
  classNameIcon?: string;
}

export function ContentReport({ classNameIcon }: IContentReportProps) {
  const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        variant='text'
        size='large'
        onlyIcon
        LeftIcon={'report_gmailerrorred'}
        iconType='material'
        classNameIcon={classNameIcon}
        onClick={() => {
          setIsReportModalOpen(true);
        }}
        className={'p-0'}
      />

      <ContentReportModal
        isOpen={isReportModalOpen}
        onClose={() => {
          setIsReportModalOpen(false);
        }}
      />
    </>
  );
}
